import { API_URL } from '../../../app-config/constants';
import { FeedbackDetailsDto } from '../../react/features/YourFeedback/types';
import { get } from '../request';

const BASE_URL = `${API_URL}/unified-feedback`;

getDetailsYouProvided.operation = 'READ';
export function getDetailsYouProvided(feedbackId: string): Promise<FeedbackDetailsDto[]> {
    return get(`${BASE_URL}/details-you-provided/${feedbackId}`);
}
